import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton } from "ui/StyledComponents/StyledButton";

const Buttons = ({primaryAction, primaryActionLabel, secondaryAction, secondaryActionLabel, noWrap}) => {
  return (
    <>
      <StyledButton
        variant="contained"
        onClick={primaryAction}
        noWrap={noWrap}
      >
        {primaryActionLabel}
      </StyledButton>

      {secondaryAction && (
        <StyledButton
          variant="outlined"
          onClick={secondaryAction}
          noWrap={noWrap}
        >
          {secondaryActionLabel}
        </StyledButton>
      )}
    </>
  );
};

Buttons.propTypes = {
  primaryAction: PropTypes.func,
  primaryActionLabel: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryActionLabel: PropTypes.string,
  noWrap: PropTypes.bool,
};

export default Buttons;